<template>
	<div style="background: #f5f5f5;margin-top: 80px;">
		<div class="home-wrapper">
			<div class="content-wrapper">
				<div class="demand-wrapper">
					<div>
						<div class="title">{{data.title}}</div>
						<div class="status">
							<el-tag v-if="data.status == 0" size="small" effect="plain">未审核</el-tag>
							<el-tag v-else-if="data.status == 1" size="small" effect="plain">已审核</el-tag>
							<el-tag v-else-if="data.status == 2" size="small" effect="plain">竞标中</el-tag>
							<el-tag v-else-if="data.status == 3" size="small" effect="plain">选标中</el-tag>
							<el-tag v-else-if="data.status == 4" size="small" style="border-color: #51C384;color: #51C384;" effect="plain">进行中</el-tag>
							<el-tag v-else-if="data.status == 5" size="small" style="border-color: #DF3535;color: #DF3535;" effect="plain">已完成</el-tag>
							<span class="publishDate">{{data.createDate}}发布</span>
						</div>
					</div>
					<div class="analyse">
						<div>需求类型：{{data.typeName}}</div>
						<div>需求介绍：{{data.details}}</div>
						<div>需求附件：</div>
						<div>需求金额：<span class="num">{{data.amount}}元</span></div>
					</div>
					<div class="btn">
						<el-button type="warning" round size="small" @click="">咨询需求</el-button>
					</div>
				</div>
				<div class="demand-list">
					<div class="top-title"><span class="icon"></span>任务推荐</div>
					<div style="display: flex;margin-top: 15px;">
						<div class="task-item" v-for="item in list"  @click="toDetail(item.id)">
							<div class="title" style="-webkit-box-orient: vertical;">{{item.title}}</div>
							<div class="type">需求类型：{{item.typeName}}</div>
							<div class="detail" style="-webkit-box-orient: vertical;">{{item.details}}</div>
							<div class="price"><span class="priceNum">{{item.amount}}元</span></div>
							<div class="status">
								<el-tag v-if="item.status == 0" size="small" effect="plain">未审核</el-tag>
								<el-tag v-else-if="item.status == 1" size="small" effect="plain">已审核</el-tag>
								<el-tag v-else-if="item.status == 2" size="small" effect="plain">竞标中</el-tag>
								<el-tag v-else-if="item.status == 3" size="small" effect="plain">选标中</el-tag>
								<el-tag v-else-if="item.status == 4" size="small" style="border-color: #51C384;color: #51C384;" effect="plain">进行中</el-tag>
								<el-tag v-else-if="item.status == 5" size="small" style="border-color: #DF3535;color: #DF3535;" effect="plain">已完成</el-tag>
								<span class="publishDate">{{item.createDate}}发布</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="sidebar">
				<div class="side-item">
					<div class="release-title">发布需求</div>
					<div class="tip">海量优质服务商随时响应需求</div>
					<div class="desc"><i class="iconfont icon-duigou"></i>海量选择 一呼百应</div>
					<div class="desc"><i class="iconfont icon-duigou"></i>智能发布 快速响应</div>
					<div class="desc"><i class="iconfont icon-duigou"></i>全程监管 安全合规</div>
					<el-button class="release-btn" type="warning" size="medium">立即发布需求</el-button>
				</div>
				<div class="side-item">
					<div class="title">团队推荐 <span class="btn" :class="{'change-btn':ischange}" @click="toggleChange" v-if="userlist.length>5"><i class="el-icon-refresh-right"></i>换一换</span></div>
					<div class="user-item" v-for="(item,index) in userlist" 
					:style="{'display':isToggle?index>=5 ?'none':'block':index<5 ?'none':'block'}"
					 @click="$router.push({name:'expert-detail',params:{id:item.userId}})">
						<div>
							<div class="head-image"><el-image :src="item.avatar" fit="fill"></el-image></div>
							<div class="user">
								<div class="name" style="-webkit-box-orient: vertical;">{{item.nickname}}</div>
								<div class="company" style="-webkit-box-orient: vertical;">{{item.companyName?item.companyName:'暂无'}}</div>
							</div>
						</div>
						<div class="user-desc" style="-webkit-box-orient: vertical;">
							<span>简介：</span>
							<span>{{item.summary}}</span>
						</div>
					</div>	
					
				</div>


			</div>
		</div>
	</div>
</template>

<script>
import { getDetail,getTaskList,getType,getUserList} from '@/api/crowd/index'
export default {
    data() {
      return {
		data: {},
		list: [],
		userlist: [],
		ischange: false,
		isToggle: true,
		page: 1
      };
    },
    methods: {
	  toggleChange(){
	  	if(this.userlist.length>5){
			this.ischange = true
			this.isToggle = !this.isToggle
			setTimeout(() => {
			  this.ischange = false;
			}, 500); 
		}
	  },
	  async getDatalist(){
	  	const res = await getTaskList({page:this.page,limit:9})
	  	if (res.code === 0) {
	  			res.data.list.forEach((item)=>{
	  				item.createDate = new Date(item.createDate).toLocaleDateString().replaceAll('/','-')
	  				this.typelist.forEach((val)=>{
	  					if(val.dictValue == item.type){
	  						item.typeName = val.dictLabel
	  					}
	  				})
	  			})
	  		this.list = res.data.list
	  		this.total = res.data.total
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	  },
	  async getTypelist(){
	  	const res = await getType()
	  	if (res.code === 0) {
	  		this.typelist = res.data[0].dataList
			this.getDatalist()
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	  },
	  async userList(){
	  	const res = await getUserList({page:this.page,limit:10})
	  	if (res.code === 0) {
	  		this.userlist = res.data.list
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	  },
      async getData(id){
      	const res = await getDetail(id)
      	if (res.code === 0) {
			res.data.createDate = new Date(res.data.createDate).toLocaleString().replaceAll('/','-')
      		this.data = res.data
			this.typelist.forEach((val)=>{
				if(val.dictValue == this.data.type){
					this.data.typeName = val.dictLabel
				}
			})
      	} else {
      	  this.$message.error(res.msg)
      	}
      },
    },
	mounted(){
		var id = this.$route.params.id
		this.getData(id)
		this.getTypelist()
		this.userList()
		window.scrollTo({top:0})
	}
  }
</script>

<style lang="scss" scoped>
.home-wrapper{
	padding-top: 20px;
	min-height: 100vh;
	max-width: 1400px;
	width: 80vw;
	margin: auto;
	.content-wrapper{
		width: calc(100% - 300px);
		display: inline-block;
	}
	.demand-wrapper{
		width: 100%;
		background: #fff;
		border-radius: 10px;
		padding: 20px;
		box-sizing: border-box;
		&>div:not(:last-child){
			border-bottom: 1px dashed #D6D6D6;
			padding: 5px 0 15px;
		}
		.title{
			font-size: 20px;
			font-weight: 800;
			margin-bottom: 8px;
		}
		.status {
			
			.publishDate{
				margin-left: 30px;
				color: #5E6165;
			}
		}
		.analyse>div{
			color: #596372;
			font-size: 15px;
			margin: 8px;
		}
		.num{
			font-size: 20px;
			color: #FF842E;
			font-weight: 800;
		}
		.btn{
			margin-top: 10px;
			.el-button--warning{
				background-color: #FF842E;
				width: 100px;
			}
		}
	}
	.demand-list{
		width: 100%;
		padding: 0;
		margin-top: 30px;
		.top-title{
			font-size: 22px;
			font-weight: 800;
			.icon{
				display: inline-block;
				width: 6px;
				height: 20px;
				background-color: #FF8632;
				border-top-right-radius: 6px;
				border-bottom-right-radius: 6px;
				margin-right: 10px;
			}
		}
		.task-item{
			flex: 0 0 32%;
			margin-right: 1%;
			background-color: #fff;
			box-shadow:  0 0 15px rgba(0,0,0,.05);
			font-size: 14px;
			color: #6D6D6D;
			padding: 20px 0;
			box-sizing: border-box;
			border-radius: 8px;
			cursor: pointer;
			&>div{
				margin-top: 8px;
				padding:  0 20px;
			}
			.title{
				color: #333333;
				font-size: 18px;
				font-weight: 800;
				margin: 0;
				overflow: hidden;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical;
				text-overflow: ellipsis;
			}
			.detail{
				overflow: hidden;
				display: -webkit-box;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;
				text-overflow: ellipsis;
				white-space: normal;
			}
			.price{
				.priceNum{
					font-size: 20px;
					color: #FF842E;
					font-weight: 800;
				}
			}
			.status {
				border-top: 1px dashed #D4D4D4;
				padding-top: 10px;
				margin-top: 20px;
				.publishDate{
					float: right;
					margin-top: 3px;
				}
			}
		}
	}
	.sidebar{
		display: inline-block;
		vertical-align: top;
		.side-item{
			width: 270px;
			box-sizing: border-box;
			padding: 24px;
			margin: 0 0 30px 30px;
			border-radius: 15px;
			box-shadow: 0 0 15px rgba(0,0,0, .05);
			background-color: #fff;
			.release-title{
				color: #FF6900;
				font-size: 20px;
				font-weight: 800;
				margin-bottom: 3px;
			}
			.tip{
				color: #FF842E;
				font-size: 15px;
				margin-bottom: 15px;
			}
			.user-item{
				margin-top: 15px;
				cursor: pointer;
			}
			.head-image{
				display: inline-block;
				margin-right: 10px;
				.el-image{
					width: 50px;
					height: 50px;
					border-radius: 50%;
				}
			}
			.user{
				display: inline-block;
				vertical-align: top;
				.name{
					font-size: 18px;
					font-weight: 800;
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 1;
					-webkit-box-orient: vertical;
					text-overflow: ellipsis;
					white-space: normal;
				}
				.company{
					color: #4B5D73;
					font-size: 14px;
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 1;
					-webkit-box-orient: vertical;
					text-overflow: ellipsis;
					white-space: normal;
				}
			}
			.user-desc{
				overflow: hidden;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				text-overflow: ellipsis;
				white-space: normal;
				font-size: 14px;
				span:last-child{
					color: #4B5D73;
				}
			}
			.desc{
				color: #596372;
				font-size: 15px;
				.icon-duigou{
					color: #FF842E;
					font-size: 12px;
					margin-right: 16px;
				}
			}
			.release-btn{
				background-color: #FF842E;
				width: 100%;
				border-radius: 20px;
				margin-top: 20px;
			}
			
			.title{
				font-size: 18px;
				font-weight: 800;
				color: #2B2B2B;
				margin-bottom: 15px;
			}
			
			.btn{
				cursor: pointer;
				float: right;
				color: #AAAEB4;
				font-weight: 500;
				font-size: 14px;
				.el-icon-refresh-right{
					font-size: 20px;
					margin-right: 5px;
					vertical-align: bottom;
				}
			}
			.change-btn{
				.el-icon-refresh-right{
					transform:rotate(360deg);
					transition: all .5s;
				}
			}
			
		}
	}
}
</style>